<template lang="pug">
  .applications__container
    the-header
    applications-list
    the-footer
</template>

<script>
import TheHeader from '../components/common/TheHeader.vue';
import TheFooter from '../components/common/TheFooter.vue';
import ApplicationsList from '../components/ApplicationsList.vue';

export default {
  name: 'ApplicationsPage',

  components: {
    TheHeader,
    TheFooter,
    ApplicationsList,
  },

  metaInfo() {
    return {
      title: 'ODIN Проекты',

      meta: [
        { vmid: 'title', name: 'title', content: 'Проекты' },
      ],

    };
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ApplicationsPage.vue